import { useParams } from 'react-router-dom';
import Button from 'style-guide/Button';
import Text from 'style-guide/Typography/Text';

const FeedbackSection = ({ feedback, isCorrect }) => {
  const { correct, wrong } = feedback || {};
  const { id, urlName } = useParams();
  const url = (chapterId) => `/learning-communities/${id}/${urlName}/member/${chapterId}/story`;
  return (
    <div className='mt--16'>
      {isCorrect !== null && (
        <div className='d-flex align-items-center'>
          <Text $variant={2}>Feedback: {isCorrect ? correct.text : wrong.text}</Text>
        </div>
      )}
      {isCorrect && correct.hyperlinks?.length > 0 && (
        <div>
          {correct.hyperlinks.map((link) => (
            <Button key={link.id} variant='link' className='mt--8' to={url(link.entityId)}>
              {link.text}
            </Button>
          ))}
        </div>
      )}
      {!isCorrect && wrong.hyperlinks?.length > 0 && (
        <div>
          {wrong.hyperlinks.map((link) => (
            <Button key={link.id} variant='link' className='mt--8 ph--0' to={url(link.entityId)}>
              {link.text}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FeedbackSection;
